import { GenericLayout } from '@/components/layouts/GenericLayout/GenericLayout';
import { Head } from '@/components/seo/Head/Head';
import { GenericIconScreen } from '@/components/shared/GenericIconScreen/GenericIconScreen';
import { Button } from '@/components/ui/Button/Button';
import { paths } from '@/config/paths';
import { BadgeX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

interface ErrorScreenProps {
  title?: string;
  description?: string;
  withSeoTitle?: boolean;
}

export const ErrorScreen = ({ title, description, withSeoTitle }: ErrorScreenProps) => {
  const { t } = useTranslation('utils', {
    keyPrefix: 'errorPage',
  });

  return (
    <GenericLayout data-testid='error-screen'>
      {withSeoTitle && <Head title={t('seo.title')} />}
      <GenericIconScreen
        Icon={BadgeX}
        title={title ?? t('title')}
        description={description ?? t('description')}
        role='alert'
        aria-live='assertive'
        leftActionElement={
          <Button className='w-full' asChild>
            <Link to={paths.home.path}>{t('button.label')}</Link>
          </Button>
        }
      />
    </GenericLayout>
  );
};
